import React, { useState } from 'react';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import { Meteor } from 'meteor/meteor';
import { Card, Button, Col, Row } from 'react-bootstrap';
import { useStyles } from '../../../styles/mapStylesCustom';

import ShareIcon from '../ShareIcon';
import ColBreak from '../ColBreak';

const ShareColumn = ({
  isShared,
  isSharedPrivate,
  isSharedUser,
  toggleShared,
  toggleSharedUser,
  toggleSharedPrivate,
  sharedPath,
  sharedPathPrivate,
  sharedPathUser
}) => {
  const textToCopy = `<div style="height: 100%; width: 100%; overflow: hidden;"><iframe src="${Meteor.absoluteUrl(
    sharedPath
  )}" height="100%" width="100%" style="border: 0px none;" >This browser does not support this element</iframe></div><p><a href="${Meteor.absoluteUrl(
    sharedPath
  )}" target="_blank">View in Ipsilum Web</a></p>`;
  const classes = useStyles();
  const [isCopied, handleCopy] = useState(false);
  return (
    <Col xs={12} sm={4} md={3} className="pr-1">
      <Row>
        <Col xs={6} sm={8} md={10}>
          <Button
            className={classes.azulIpsilumButton}
            variant="outline"
            onClick={toggleShared}
            block
          >
            {isShared ? 'Cerrar compartir mapa público' : 'Compartir mapa público'}
          </Button>
        </Col>
        <Col xs={6} sm={4} md={2} className="d-flex justify-content-center">
          <ShareIcon shared={isShared} />
        </Col>
        <ColBreak />
        {isShared && (
          <Col xs={12}>
            <Card bg="light">
              <Card.Body>
                <Card.Subtitle>Shared Link</Card.Subtitle>
                <Card.Link
                  href={Meteor.absoluteUrl(sharedPath)}
                  target="_blank"
                  className={`text-break ${classes.azulIpsilum}`}
                  rel="noopener noreferrer"
                >
                  {Meteor.absoluteUrl(sharedPath)}
                </Card.Link>
              </Card.Body>
            </Card>
            <Card bg="light">
              <Card.Header>
                iframe Code
                <Button
                  variant="outline-primary"
                  className={`float-right ${classes.azulIpsilumButton}`}
                  size="sm"
                  onClick={() => {
                    copy(textToCopy);
                    handleCopy(true);
                  }}
                >
                  {isCopied ? 'Copied' : 'Copy'}
                </Button>
              </Card.Header>
              <Card.Body>
                <pre className="pre-scrollable text-truncate overflow-hidden">
                  <code className="language-html" data-lang="html">
                    {textToCopy}
                  </code>
                </pre>
              </Card.Body>
            </Card>
          </Col>
        )}
      </Row>
      <br />
      <Row>
        <Col xs={6} sm={8} md={10}>
          <Button
            className={classes.azulIpsilumButton}
            variant="outline"
            onClick={toggleSharedPrivate}
            block
          >
            {isSharedPrivate ? 'Cerrar compartir mapa privado' : 'Compartir mapa privado'}
          </Button>
        </Col>
        <Col xs={6} sm={4} md={2} className="d-flex justify-content-center">
          <ShareIcon shared={isSharedPrivate} />
        </Col>
        <ColBreak />
        {isSharedPrivate && (
          <Col xs={12}>
            <Card bg="light">
              <Card.Body>
                <Card.Subtitle>Shared Link</Card.Subtitle>
                <Card.Link
                  href={Meteor.absoluteUrl(sharedPathPrivate)}
                  target="_blank"
                  className={`text-break ${classes.azulIpsilum}`}
                  rel="noopener noreferrer"
                >
                  {Meteor.absoluteUrl(sharedPathPrivate)}
                </Card.Link>
              </Card.Body>
            </Card>
            <Card bg="light">
              <Card.Header>
                iframe Code
                <Button
                  variant="outline-primary"
                  className={`float-right ${classes.azulIpsilumButton}`}
                  size="sm"
                  onClick={() => {
                    copy(textToCopy);
                    handleCopy(true);
                  }}
                >
                  {isCopied ? 'Copiado' : 'Copiar'}
                </Button>
              </Card.Header>
              <Card.Body>
                <pre className="pre-scrollable text-truncate overflow-hidden">
                  <code className="language-html" data-lang="html">
                    {textToCopy}
                  </code>
                </pre>
              </Card.Body>
            </Card>
          </Col>
        )}
      </Row>
      <br />
      <Row>
        <Col xs={6} sm={8} md={10}>
          <Button
            className={classes.azulIpsilumButton}
            variant="outline"
            onClick={toggleSharedUser}
            block
          >
            {isSharedUser
              ? 'Cerrar compartir mapa público con usuarios'
              : 'Compartir mapa público con usuarios'}
          </Button>
        </Col>
        <Col xs={6} sm={4} md={2} className="d-flex justify-content-center">
          <ShareIcon shared={isSharedUser} />
        </Col>
        <ColBreak />
        {isSharedUser && (
          <Col xs={12}>
            <Card bg="light">
              <Card.Body>
                <Card.Subtitle>Shared Link</Card.Subtitle>
                <Card.Link
                  href={Meteor.absoluteUrl(sharedPathUser)}
                  target="_blank"
                  className={`text-break ${classes.azulIpsilum}`}
                  rel="noopener noreferrer"
                >
                  {Meteor.absoluteUrl(sharedPathUser)}
                </Card.Link>
              </Card.Body>
            </Card>
            <Card bg="light">
              <Card.Header>
                iframe Code
                <Button
                  variant="outline-primary"
                  className={`float-right ${classes.azulIpsilumButton}`}
                  size="sm"
                  onClick={() => {
                    copy(textToCopy);
                    handleCopy(true);
                  }}
                >
                  {isCopied ? 'Copied' : 'Copy'}
                </Button>
              </Card.Header>
              <Card.Body>
                <pre className="pre-scrollable text-truncate overflow-hidden">
                  <code className="language-html" data-lang="html">
                    {textToCopy}
                  </code>
                </pre>
              </Card.Body>
            </Card>
          </Col>
        )}
      </Row>
      <br />
      {/* <Row>
        <Col xs={6} sm={8} md={10}>
          <Button
            className={classes.azulIpsilumButton}
            variant="outline"
            onClick={toggleSharedPrivate}
            block
          >
            {isSharedPrivate ? 'Cerrar compartir mapa privado' : 'Compartir mapa privado'}
          </Button>
        </Col>
        <Col xs={6} sm={4} md={2} className="d-flex justify-content-center">
          <ShareIcon shared={isSharedPrivate} />
        </Col>
        <ColBreak />
        {isSharedPrivate && (
          <Col xs={12}>
            <Card bg="light">
              <Card.Body>
                <Card.Subtitle>Shared Link</Card.Subtitle>
                <Card.Link
                  href={Meteor.absoluteUrl(sharedPathPrivate)}
                  target="_blank"
                  className={`text-break ${classes.azulIpsilum}`}
                  rel="noopener noreferrer"
                >
                  {Meteor.absoluteUrl(sharedPathPrivate)}
                </Card.Link>
              </Card.Body>
            </Card>
            <Card bg="light">
              <Card.Header>
                iframe Code
                <Button
                  variant="outline-primary"
                  className={`float-right ${classes.azulIpsilumButton}`}
                  size="sm"
                  onClick={() => {
                    copy(textToCopy);
                    handleCopy(true);
                  }}
                >
                  {isCopied ? 'Copiado' : 'Copiar'}
                </Button>
              </Card.Header>
              <Card.Body>
                <pre className="pre-scrollable text-truncate overflow-hidden">
                  <code className="language-html" data-lang="html">
                    {textToCopy}
                  </code>
                </pre>
              </Card.Body>
            </Card>
          </Col>
        )}
      </Row> */}
    </Col>
  );
};
ShareColumn.propTypes = {
  isShared: PropTypes.bool.isRequired,
  isSharedPrivate: PropTypes.bool.isRequired,
  isSharedUser: PropTypes.bool.isRequired,
  toggleShared: PropTypes.func.isRequired,
  toggleSharedPrivate: PropTypes.func.isRequired,
  toggleSharedUser: PropTypes.func.isRequired,
  sharedPath: PropTypes.string.isRequired,
  sharedPathUser: PropTypes.string.isRequired,
  sharedPathPrivate: PropTypes.string.isRequired
};

export default ShareColumn;
